import produce from "immer";
import {
  SET_TOPIC_LIST_DATA,
  GET_VOCABULARY_CONTENTS,
  GET_VOCABULARY_CONTENTS_SUCCESS,
  GET_VOCABULARY_CONTENTS_FAILURE,
  GET_VOCABULARY_WORD_LIST,
  GET_VOCABULARY_WORD_LIST_SUCCESS,
  GET_VOCABULARY_WORD_LIST_FAILURE,
  GET_VOCABULARY_SEARCHED_WORD,
  GET_VOCABULARY_SEARCHED_WORD_SUCCESS,
  GET_VOCABULARY_SEARCHED_WORD_FAILURE,
  VOCABULARY_RESET_SEARCH_PARAMS,
  CREATE_VOCABULARY_WORDLIST,
  CREATE_VOCABULARY_WORDLIST_SUCCESS,
  CREATE_VOCABULARY_WORDLIST_FAILURE,
  RESET_CREATED_WORDLIST_STATUS,
  UPDATE_VOCABULARY_WORD_NOTE,
  UPDATE_VOCABULARY_WORD_NOTE_SUCCESS,
  UPDATE_VOCABULARY_WORD_NOTE_FAILURE,
  RESET_UPDATE_VOCABULARY_WORD_STATUS,
  VOCABULARY_ADD_WORD_TO_LIST,
  VOCABULARY_ADD_WORD_TO_LIST_SUCCESS,
  VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
  RESET_VOCABULARY_ADD_WORD_TO_LIST,
  VOCABULARY_ADD_WORD,
  VOCABULARY_ADD_WORD_SUCCESS,
  VOCABULARY_ADD_WORD_FAILURE,
  RESET_VOCABULARY_ADD_WORD,
  VOCABULARY_DELETE_WORDLIST,
  RESET_VOCABULARY_DELETE_WORDLIST,
  VOCABULARY_DELETE_WORDLIST_FAILURE,
  VOCABULARY_DELETE_WORDLIST_SUCCESS,
  VOCABULARY_DELETE_WORD,
  VOCABULARY_DELETE_WORD_SUCCESS,
  VOCABULARY_DELETE_WORD_FAILURE,
  RESET_VOCABULARY_DELETE_WORD,
  VOCABULARY_UPDATE_WORD_LIST,
  VOCABULARY_UPDATE_WORD_LIST_SUCCESS,
  VOCABULARY_UPDATE_WORD_LIST_FAILURE,
  RESET_VOCABULARY_UPDATE_WORD_LIST,
} from "../constants";

const reducerInitialState: any = {
  isLoading: false,
  isSubTopicLoading: false,
  headerLevelContents: {},
  topicLevelContent: {},
  error: {},
  subTopicError: {},
  searchedWordDetails: {},
  isSearchedWordDetailsAvailable: null,
  searchedWordError: {},
  isWordSearching: null,
  isWordListCreating: false,
  isWordListCreated: false,
  errorOnNewWordListCreation: {},
  isWordNoteUpdating: false,
  isWordNoteUpdated: false,
  editedNoteDetails: {},
  errorOnWordNoteUpdating: {},
  isWordAddingToList: false,
  isWordAddedToList: false,
  errorOnAddingWordToList: {},
  isWordCreating: false,
  errorOnWordCreating: {},
  isWordListDeleting: false,
  isWordListDeleted: false,
  errorOnDeletingWordList: {},
  isWordDeleting: false,
  isWordDeleted: false,
  errorOnDeletingWord: {},
  isWordListUpdating: false,
  isWordListUpdated: false,
  errorOnNewWordListUpdating: {},
  topicsListData: null,
};

const updatePeopleInformation = function (state = reducerInitialState, action: any) {
  switch (action.type) {
    case GET_VOCABULARY_CONTENTS:
      return produce(state, (draftState: any) => {
        draftState.isLoading = true;
      });
    case GET_VOCABULARY_CONTENTS_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isLoading = false;
        draftState.headerLevelContents = action.payload;
      });
      case SET_TOPIC_LIST_DATA:
        return produce(state, (draftState: any) => {
          draftState.topicsListData = action.payload;
        });
    case GET_VOCABULARY_CONTENTS_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.isLoading = false;
        draftState.error = action.error;
      });
    case GET_VOCABULARY_WORD_LIST:
      return produce(state, (draftState: any) => {
        draftState.isSubTopicLoading = true;
      });
    case GET_VOCABULARY_WORD_LIST_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.topicLevelContent = action.payload;
        draftState.isSubTopicLoading = false;
      });
    case GET_VOCABULARY_WORD_LIST_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.subTopicError = action.error;
        draftState.isSubTopicLoading = false;
      });
    case GET_VOCABULARY_SEARCHED_WORD:
      return produce(state, (draftState: any) => {
        draftState.isWordSearching = true;
        draftState.searchedWordError = {};
        draftState.searchedWordDetails = {};
      });
    case GET_VOCABULARY_SEARCHED_WORD_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.searchedWordDetails = action.payload;
        draftState.isWordSearching = false;
        draftState.isSearchedWordDetailsAvailable = true;
      });
    case GET_VOCABULARY_SEARCHED_WORD_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.searchedWordDetails = {};
        draftState.searchedWordError = action.error;
        draftState.isWordSearching = false;
        draftState.isSearchedWordDetailsAvailable = false;
      });
    case VOCABULARY_RESET_SEARCH_PARAMS:
      return produce(state, (draftState: any) => {
        draftState.searchedWordDetails = {};
        draftState.isWordSearching = null;
        draftState.isSearchedWordDetailsAvailable = null;
        draftState.searchedWordError = {};
      });
    case CREATE_VOCABULARY_WORDLIST:
      return produce(state, (draftState: any) => {
        draftState.isWordListCreating = true;
      });
    case CREATE_VOCABULARY_WORDLIST_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordListCreated = true;
        draftState.isWordListCreating = false;
      });
    case CREATE_VOCABULARY_WORDLIST_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.errorOnNewWordListCreation = action.error;
        draftState.isWordListCreating = false;
      });
    case RESET_CREATED_WORDLIST_STATUS:
      return produce(state, (draftState: any) => {
        draftState.isWordListCreated = false;
        draftState.isWordListCreating = false;
        draftState.errorOnNewWordListCreation = {};
      });
    case UPDATE_VOCABULARY_WORD_NOTE:
      return produce(state, (draftState: any) => {
        draftState.isWordNoteUpdating = true;
      });
    case UPDATE_VOCABULARY_WORD_NOTE_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.editedNoteDetails = action.payload.update[0] ?? {};
        draftState.isWordNoteUpdated = true;
        draftState.isWordNoteUpdating = false;
      });
    case UPDATE_VOCABULARY_WORD_NOTE_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.errorOnWordNoteUpdating = action.error;
        draftState.isWordNoteUpdating = false;
      });
    case RESET_UPDATE_VOCABULARY_WORD_STATUS:
      return produce(state, (draftState: any) => {
        draftState.isWordNoteUpdating = false;
        draftState.isWordNoteUpdated = false;
        draftState.editedNoteDetails = {};
        draftState.errorOnWordNoteUpdating = {};
      });
    case VOCABULARY_ADD_WORD_TO_LIST:
      return produce(state, (draftState: any) => {
        draftState.isWordAddingToList = true;
      });
    case VOCABULARY_ADD_WORD_TO_LIST_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordAddedToList = true;
        draftState.isWordAddingToList = false;
      });
    case VOCABULARY_ADD_WORD_TO_LIST_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.errorOnAddingWordToList = action.error;
        draftState.isWordAddingToList = false;
      });
    case RESET_VOCABULARY_ADD_WORD_TO_LIST:
      return produce(state, (draftState: any) => {
        draftState.errorOnAddingWordToList = {};
        draftState.isWordAddedToList = false;
        draftState.isWordAddingToList = false;
      });
    case VOCABULARY_ADD_WORD:
      return produce(state, (draftState: any) => {
        draftState.isWordCreating = true;
      });
    case VOCABULARY_ADD_WORD_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordCreating = false;
      });
    case VOCABULARY_ADD_WORD_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.isWordCreating = false;
        draftState.errorOnWordCreating = action.error;
      });
    case RESET_VOCABULARY_ADD_WORD:
      return produce(state, (draftState: any) => {
        draftState.isWordCreating = false;
        draftState.errorOnWordCreating = {};
      });
    case VOCABULARY_DELETE_WORDLIST:
      return produce(state, (draftState: any) => {
        draftState.isWordListDeleting = true;
      });
    case VOCABULARY_DELETE_WORDLIST_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordListDeleting = false;
        draftState.isWordListDeleted = true;
      });
    case VOCABULARY_DELETE_WORDLIST_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.isWordListDeleting = false;
        draftState.errorOnDeletingWordList = action.error;
      });
    case RESET_VOCABULARY_DELETE_WORDLIST:
      return produce(state, (draftState: any) => {
        draftState.isWordListDeleting = false;
        draftState.isWordListDeleted = false;
        draftState.errorOnDeletingWordList = {};
      });
    case VOCABULARY_DELETE_WORD:
      return produce(state, (draftState: any) => {
        draftState.isWordDeleting = true;
      });
    case VOCABULARY_DELETE_WORD_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordDeleting = false;
        draftState.isWordDeleted = true;
      });
    case VOCABULARY_DELETE_WORD_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.isWordDeleting = false;
        draftState.errorOnDeletingWord = action.error;
      });
    case RESET_VOCABULARY_DELETE_WORD:
      return produce(state, (draftState: any) => {
        draftState.isWordDeleting = false;
        draftState.isWordDeleted = false;
        draftState.errorOnDeletingWord = {};
      });
    case VOCABULARY_UPDATE_WORD_LIST:
      return produce(state, (draftState: any) => {
        draftState.isWordListUpdating = true;
      });
    case VOCABULARY_UPDATE_WORD_LIST_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isWordListUpdating = false;
        draftState.isWordListUpdated = true;
      });
    case VOCABULARY_UPDATE_WORD_LIST_FAILURE:
      return produce(state, (draftState: any) => {
        draftState.isWordListUpdating = false;
        draftState.errorOnNewWordListUpdating = action.error;
      });
    case RESET_VOCABULARY_UPDATE_WORD_LIST:
      return produce(state, (draftState: any) => {
        draftState.isWordListUpdating = false;
        draftState.isWordListUpdated = false;
        draftState.errorOnNewWordListUpdating = {};
      });
    default:
      return state;
  }
};

export default updatePeopleInformation;
